// @flow
import React from 'react';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import IconLabel from '../util/IconLabel';
import styles from './DownloadIndicator.css';
import { commonMessages } from '../messages/Common';

type OwnProps = {
  trackIsDownloaded?: boolean,
  trackIsDownloading?: boolean,
  className?: string,
};

type Props = OwnProps & {
  intl: IntlShape,
};

const DownloadIndicator = ({ trackIsDownloaded, trackIsDownloading, className, intl }: Props) => {
  if (trackIsDownloaded) {
    return (
      <div
        className={classnames(className, styles.downloadIndicator)}
        aria-label={intl.formatMessage(commonMessages.downloaded)}
        role="img"
      >
        <IconLabel name="download-circle-block" size="small" className={styles.downloadIcon} />
      </div>
    );
  }
  if (trackIsDownloading) {
    return (
      <div
        className={classnames(className, styles.downloadIndicator)}
        aria-label={intl.formatMessage(commonMessages.downloading)}
        role="img"
      >
        <div className={styles.spinner} />
      </div>
    );
  }
  return null;
};

export default injectIntl(DownloadIndicator);
